import { render } from "./AddAwards.vue?vue&type=template&id=4dcd8546&scoped=true"
import script from "./AddAwards.vue?vue&type=script&lang=js"
export * from "./AddAwards.vue?vue&type=script&lang=js"

import "./AddAwards.vue?vue&type=style&index=0&id=4dcd8546&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcd8546"]])

export default __exports__